// extracted by mini-css-extract-plugin
export var White = "Reviews-module--White--37027";
export var cta = "Reviews-module--cta--dd5b9";
export var fadeIn = "Reviews-module--fadeIn--83ddd";
export var image = "Reviews-module--image--6fb3f";
export var review = "Reviews-module--review--70f5c";
export var reviews = "Reviews-module--reviews--bdef3";
export var visible = "Reviews-module--visible--fbb83";